import React, {useEffect, useState} from "react";
import {Card, CardContent, CardDescription, CardHeader, CardTitle} from "../components/ui/Card";
import {ChevronRight} from "lucide-react";
import {Link, useParams} from "react-router-dom";
import {
    PiThermometerColdFill,
    PiThermometerFill, PiThermometerHotFill,
    PiThermometerSimpleFill,
    PiWifiHighFill,
    PiWifiLowFill,
    PiWifiMediumFill
} from "react-icons/pi";
import {BsThermometerSun} from "react-icons/bs";
import DataTable from "../components/DataTable";
import {loggerColumns, piezometerColumns} from "../components/Columns";
import loggersData from "../data/loggers.json";
import piezometerData from "../data/pzData.json";

function LoggerPage() {
    const {siteId} = useParams();
    const {userId} = useParams();
    const {loggerId} = useParams();

    const [data, setData] = useState({});
    const [pzData, setPzData] = useState([]);

    useEffect(() => {
        setData([])
        setPzData([])

        loggersData.filter((search) => parseInt(search.loggerId) === parseInt(loggerId)).map((item) => {
            setData({ ...item,
                loggerName: item.loggerName,
            })
        })
        piezometerData.map((item) => {
            setPzData((oldArray) => [...oldArray, item])
        })
    }, [])

    return (
        <div className="w-11/12 mx-auto mt-4 space-y-8">
            {console.log(piezometerData)}
            <Card>
                <CardContent className="flex gap-x-0.5 items-center">
                    <CardHeader className="font-bold">All Sites</CardHeader>
                    <ChevronRight/>
                    <CardHeader className="underline text-[#408EFAFF]">
                        <Link to={`/dashboard/${userId}/analysis`}>Site Detail</Link>
                    </CardHeader>
                    <ChevronRight/>
                    <CardHeader className="underline text-[#408EFAFF]">
                        <Link to={`/dashboard/${userId}/analysis/${siteId}`}>Logger Detail</Link>
                    </CardHeader>
                </CardContent>
            </Card>
            <Card className="grid grid-cols-2 w-full">
                <div>
                    <CardHeader>
                        <CardTitle className="text-black border-dashed border-b pb-2 font-extralight">
                            Logger Details
                        </CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="grid grid-cols-2 gap-1">
                            <p className="font-bold">Site ID:</p>
                            <CardDescription>{siteId}</CardDescription>
                        </div>
                        <div className="grid grid-cols-2 gap-1">
                            <p className="font-bold">Logger ID:</p>
                            <CardDescription>{loggerId}</CardDescription>
                        </div>
                        <div className="grid grid-cols-2 gap-1">
                            <p className="font-bold">Logger Name:</p>
                            <CardDescription>{data.loggerName}</CardDescription>
                        </div>
                    </CardContent>
                </div>
                <div>
                    <CardHeader>
                        <CardTitle className="text-black border-dashed border-b pb-2 font-extralight">Piezometer
                            Legend</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="flex gap-x-2">
                            <PiThermometerFill color="green" className="mt-0.5"/>
                            <CardDescription>Reading with normal range</CardDescription>
                        </div>
                        <div className="flex gap-x-2">
                            <BsThermometerSun color="orange" className="mt-0.5"/>
                            <CardDescription>Engineering unit exceeding defined threshold</CardDescription>
                        </div>
                        <div className="flex gap-x-2">
                            <PiThermometerSimpleFill color="maroon" className="mt-0.5"/>
                            <CardDescription>Temperature out of defined threshold</CardDescription>
                        </div>
                        <div className="flex gap-x-2">
                            <PiThermometerHotFill color="red" className="mt-0.5"/>
                            <CardDescription>Engineering unit exceeding critical threshold</CardDescription>
                        </div>
                        <div className="flex gap-x-2">
                            <PiThermometerColdFill color="black" className="mt-0.5"/>
                            <CardDescription>Faulty reading exceeding critical threshold</CardDescription>
                        </div>
                    </CardContent>
                </div>
            </Card>
            <Card>
                <CardHeader>
                    <DataTable columns={piezometerColumns} data={pzData}/>
                </CardHeader>
            </Card>
        </div>
    )
}

export default LoggerPage;